import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  mounted () {
    this.renderChart({
      labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      datasets: [
        {
          label: 'Temperatura média',
          backgroundColor: '#f6ede0',
          data: [13, 14, 17, 20, 25, 30, 34, 35, 30, 25, 17, 14]

        }
      ]
    }, {
      responsive: true,
      maintainAspectRatio: false
    })
  }
}